import { Flex } from '@mantine/core'
import { forwardRef } from 'react'
import type { Props } from '../node/definition'
// justify={p.justify}
// align={p.align}
// direction={p.direction}
// wrap={p.wrap}
export default forwardRef((p: Props) => {
	return (
		<Flex

			{...p}
			{...p.customProps}>
			{p.children}
		</Flex>
	)
})
